const capitalizeFirstLetter = (string: string): string => {
  // Regex parses a word (text separated by spaces ignoring special characters for words like don't)
  return string.replace(/\w\S*/g, function(txt) {
    // Replaces that word with a version of the word where the first character is uppercase and the rest are lowercase
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export default capitalizeFirstLetter;
